import { render } from "./DashboardLots.vue?vue&type=template&id=d05b3e7e&scoped=true&ts=true&lang=pug"
import script from "./DashboardLots.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardLots.vue?vue&type=script&lang=ts&setup=true"

import "./DashboardLots.vue?vue&type=style&index=0&id=d05b3e7e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d05b3e7e"]])

export default __exports__